/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The javascript of OmegaTrackerCDNGlobal
 */

import OmegaTracker from 'com/didichuxing/tracker/h5/OmegaTracker';

(function(global) {
    global.Omega = global.Omega || {};
    if (!global.Omega.trackEvent || typeof global.Omega.trackEvent !== 'function') { // 没有实例化前，Omega为配置。
        if (!global.Omega.uploadHost) { // 未设置uploadHost时，默认为didiglobal host
            global.Omega.uploadHost = 'omgup.didiglobal.com';
        }
        global.Omega = OmegaTracker.getTracker(global.Omega);
    }
})(window);
